import { APP_CLEAR_CURRENT_USER } from '../actions/app.actions'
import * as Actions from '../actions/fanpageDatos.actions'

const initialState = {
  pages: [],
  selectedPage: null,
  postId: '',
}

export default (state = initialState, action) => {
  switch (action.type) {
    case Actions.FB_PROP:
      return {
        ...state,
        [action.prop.name]: action.prop.value,
      }
    case Actions.FB_PAGES:
      return {
        ...state,
        pages: action.pages,
      }
    case Actions.FB_DATOS:
      return {
        ...state,
        posts: action.posts,
        reactions: action.reactions,
        comments: [],
        postId: '',
      }
    case Actions.FB_COMMENTS:
      return {
        ...state,
        postId: action.postId,
        comments: action.comments,
      }
    case APP_CLEAR_CURRENT_USER:
      return initialState
    default:
      return state
  }
}